import { render, staticRenderFns } from "./BetaBadge.vue?vue&type=template&id=ad4afbdc&scoped=true"
import script from "./BetaBadge.vue?vue&type=script&lang=js"
export * from "./BetaBadge.vue?vue&type=script&lang=js"
import style0 from "./BetaBadge.vue?vue&type=style&index=0&id=ad4afbdc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad4afbdc",
  null
  
)

export default component.exports